// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27ULO","label":"styles_label__2cH2-"};